import React, { Component } from 'react'
import Style from '../UserLicenseDetails.module.css'
import { connect } from 'react-redux'
import { formatDetectionDatetime } from '../../utilities/datetime'
import { setCurrentCustomer } from '../../store/entities/customers'
import { getDevicesForUser, getExtensionInstalls, getLmUsers } from '../../store/entities/lmDevicesUsers'
import { isGlobalView } from '../../utilities/config'
import BackIcon from '../../assets/backButton.svg'
import LoaderWrapper from '../common/LoaderWrapper/LoaderWrapper'

class UserDetails extends Component {
  state = {
    setCustomerOnce: true,
    expandedDevices: {},
  }

  toggleDevice = (deviceId) => {
    this.setState((prevState) => ({
      expandedDevices: {
        ...prevState.expandedDevices,
        [deviceId]: !prevState.expandedDevices[deviceId],
      },
    }))
  }

  fetchUsersData = () => {
    const userId = this.props.match.params.userId
    const selectedId = this.props.match.params.customerId
    // const defaultCustomerId = this.props.selectedCustomer?.defaultCustomerId
    // const globalView = isGlobalView(this.props.selectedCustomer?.organizationName)
    this.props.getDevicesForUser(userId, selectedId)
  }

  componentDidMount() {
    if (this.props.selectedCustomer) {
      if(!this.props.selectedUser){
        this.props.getLmUsers(null, this.props.match.params.customerId, this.props.selectedCustomer?.defaultCustomerId, isGlobalView(this.props.selectedCustomer?.organizationName), this.props.match.params.userId)
      }
      this.fetchUsersData()
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props && this.state.setCustomerOnce && this.props.orgList.length > 0) {
        this.setState({
          setCustomerOnce: false,
        })

        let filtredElement = this.props.orgList.filter((ele) => ele.id === this.props.match.params.customerId)
  
        if (filtredElement[0].id !== this.props.selectedCustomer.id) {
          this.props.setCurrentCustomer(filtredElement[0]);
        }
      }
    if (prevProps.selectedCustomer !== this.props.selectedCustomer && this.props.selectedCustomer) {
      this.fetchUsersData()
    }
  }

  handleClick = () => {
    !isGlobalView(this.props.selectedCustomer?.organizationName) ? 
    this.props.history.push({
      pathname: `/customers/${this.props.match.params.customerId}/license-management`,
      state: { tab: 'User Info' },
    })
    :
    this.props.history.push({
      pathname: `/tenants/${this.props.match.params.tenantId}/license-management`,
      state: { tab: 'User Info' },
    })
  }

  loadExtensionInstalls = (deviceId) => {
    const userId = this.props.match.params.userId
    const isCurrentlyExpanded = this.state.expandedDevices[deviceId];
    this.toggleDevice(deviceId)
    // Only fetch if expanding and installs not already loaded for this user+device
    if (!isCurrentlyExpanded) {
      const alreadyLoaded = this.props.extensionInstalls.some(
        ext => String(ext.UserId) === String(userId) && String(ext.DeviceId) === String(deviceId)
      );
      if (!alreadyLoaded) {
        const selectedId = this.props.match.params.customerId
        console.log('Fetching extension installs for user', {selectedId, userId, deviceId})
        this.props.getExtensionInstalls(selectedId, userId, deviceId)
      }
    }
  }

  render() {
    const userId = this.props.match.params.userId
    const devices = this.props.userDevices || []
    const extensionInstalls = this.props.extensionInstalls || []

    // Group devices by deviceId
    const groupedDevices = {}
    devices.forEach((device) => {
      if (!groupedDevices[device.deviceId]) {
        groupedDevices[device.deviceId] = { deviceId: device.deviceId, deviceName: device.OSComputerName || device.DeviceIdentifier || device.deviceId, isActive: device.isActive, CreatedOn: device.CreatedOn }
      }
    })
    const deviceGroups = Object.values(groupedDevices)
    const activeDevices = deviceGroups.filter((g) => g.isActive)
    const inactiveDevices = deviceGroups.filter((g) => !g.isActive)

    const userName = this.props.selectedUser?.UserIdentifier

    return (
      <div className={'mt-4'} style={{ paddingLeft: '75px', marginRight: '33px' }}>
        <div className={`${Style.headerBg} d-flex align-items-center justify-content-between`} style={{ paddingLeft: '29px' }}>
          <div onClick={this.handleClick} style={{ cursor: 'pointer' }}>
            <img style={{ height: '19px' }} src={BackIcon} alt={'back-icon'} />
            {' '}Return to User Info
          </div>
        </div>

        {this.props.userDevicesLoading ? (
          <LoaderWrapper loading={true} waitForData={false} isFlex={true} styles={{ top: '100px', minHeight: '300px' }} />
        ) : (
        <div className={`mt-4`} style={{ minHeight: '300px' }}>
          <div style={{ paddingLeft: '34px' }}>
            <b>User: {userName}</b>
          </div>
          <div className={`${Style.detailsContainer} mt-2 d-flex scrollX`}>
            <div className={'p-4'} style={{ minWidth: '300px' }}>
              <table className={Style.leftTable}>
                <tbody>
                  <tr>
                    <td className={`py-3 px-2`}><b>Total Devices</b></td>
                    <td className={`py-3 px-2`}>{deviceGroups.length}</td>
                  </tr>
                  <tr>
                    <td className={`py-3 px-2`}><b>Active Devices</b></td>
                    <td className={`py-3 px-2`} style={{ color: '#85ceae', fontWeight: 'bold' }}>{activeDevices.length}</td>
                  </tr>
                  <tr>
                    <td className={`py-3 px-2`}><b>Inactive Devices</b></td>
                    <td className={`py-3 px-2`} style={{ color: '#e57373', fontWeight: 'bold' }}>{inactiveDevices.length}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className={Style.divider}></div>
            <div className={`p-4`} style={{ minWidth: '850px' }}>
              <table className={Style.rightTable}>
                <thead>
                  <tr>
                    <td className={`py-3 px-2`} style={{ width: '40%' }}><b>Device Name</b></td>
                    <td className={`py-3 px-2`} style={{ width: '25%' }}><b>Status</b></td>
                    <td className={`py-3 px-2`} style={{ width: '35%' }}><b>Last Synced</b></td>
                  </tr>
                </thead>
                <tbody>
                  {deviceGroups.map((group) => {
                    const isExpanded = this.state.expandedDevices[group.deviceId]
                    return (
                      <React.Fragment key={group.deviceId}>
                        <tr
                          style={{ boxShadow: 'none', background: '#fff', cursor: 'pointer' }}
                          onClick={() => this.loadExtensionInstalls(group.deviceId)}
                        >
                          <td className={`py-3 px-2`}>
                            <span style={{ marginRight: '6px', display: 'inline-block', transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>&#9654;</span>
                            {group.deviceName}
                          </td>
                          <td className={`py-3 px-2`} style={{ color: group.isActive ? '#85ceae' : '#e57373', fontWeight: 'bold' }}>
                            {group.isActive ? 'Active' : 'Inactive'}
                          </td>
                          <td className={`py-3 px-2`}>{formatDetectionDatetime(group.CreatedOn)}</td>
                        </tr>
                        {isExpanded && (() => {
                          const installs = extensionInstalls.filter(
                            e => String(e.DeviceId) === String(group.deviceId) && String(e.UserId) === String(userId)
                          );
                          return this.props.extensionInstallsLoading && installs.length === 0 ? (
                            <tr style={{ boxShadow: 'none', background: '#f9f9f9' }}>
                              <td colSpan="3"><LoaderWrapper loading={true} waitForData={false} isFlex={true} styles={{ minHeight: '40px' }} /></td>
                            </tr>
                          ) : installs.map((inst, idx) => (
                            <tr key={`${group.deviceId}-${idx}`} style={{ boxShadow: 'none', background: '#f9f9f9' }}>
                              <td className={`py-2 px-2`} style={{ paddingLeft: '32px' }}>{inst.browser} {inst.BrowserVersion}</td>
                              <td className={`py-2 px-2`} style={{ color: inst.isActive ? '#85ceae' : '#e57373', fontWeight: 'bold' }}>
                                {inst.isActive ? 'Active' : 'Inactive'}
                              </td>
                              <td className={`py-2 px-2`}>{formatDetectionDatetime(inst.LastHeartbeat)}</td>
                            </tr>
                          ));
                        })()}
                      </React.Fragment>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  selectedCustomer: state.entities.customers.selected,
  orgList: state.entities.customers.list,
  userDevices: state.entities.lmDevicesUsers.userDevices,
  userDevicesLoading: state.entities.lmDevicesUsers.userDevicesLoading,
  selectedUser: state.entities.lmDevicesUsers.selectedUser,
  extensionInstalls: state.entities.lmDevicesUsers.extensionInstalls,
  extensionInstallsLoading: state.entities.lmDevicesUsers.extensionInstallsLoading,
})

const mapDispatchToProps = (dispatch) => ({
  setCurrentCustomer: (customerId) => dispatch(setCurrentCustomer(customerId)),
  getDevicesForUser: (userId, selectedId) => dispatch(getDevicesForUser(userId, selectedId)),
  getExtensionInstalls: (selectedId, userId, deviceId) => dispatch(getExtensionInstalls(selectedId, userId, deviceId)),
  getLmUsers: (filters, selectedId, defaultCustomerId, isGlobalView, userId=null) => dispatch(getLmUsers(filters, selectedId, defaultCustomerId, isGlobalView, userId)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UserDetails)
